import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { InboxDelivery } from 'app/core/models';
import { ModalReactivateComponent } from '../modal-reactivate/modal-reactivate.component';

@Component({
  standalone: false,
  selector: 'pptl-reactivate-btn',
  templateUrl: 'reactivate-btn.component.html',
  styleUrls: ['reactivate-btn.component.scss'],
})
export class ReactivateBtnComponent {
  @Input() delivery: InboxDelivery;

  constructor(public modalControllerReactivate: ModalController) {}

  reactivate() {
    if (!this.delivery?.resendRequested) {
      this.showReactivateDeliveryModal();
    }
  }

  async showReactivateDeliveryModal() {
    const modalReactivateDelivery = await this.modalControllerReactivate.create({
      component: ModalReactivateComponent,
      cssClass: 'delivery-modal-reactivate',
      componentProps: { delivery: this.delivery },
    });

    await modalReactivateDelivery.present();
  }
}
